import type { SpacerContent } from '@mawkaa/types';

interface SpacerBlockProps {
  content: SpacerContent;
}

export function SpacerBlock({ content }: SpacerBlockProps) {
  const { height = 60 } = content;

  return <div style={{ height: `${height}px` }} />;
}
